/**
 * author       : zwl
 * createTime   : 2018/6/28 下午5:08
 * description  :
 */
import api from 'util/axios'

export function getMenuList () {
  return api({
    method: 'get',
    url: '/sys/menu/list/'
  })
}

export function getList () {
  return api({
    method: 'get',
    url: '/permission/list/'
  })
}
